import { instance } from '@/api'
import { createBaseApi } from '@/api/baseApi'

const CONSIGNMENT_URL = 'consignment/consignments'
export default {
  ...createBaseApi(CONSIGNMENT_URL),
  updateExecutor: (id, data) => {
    return instance.post(`/${CONSIGNMENT_URL}/${id}/executor`, data)
  },
  getStageLine: id => {
    return instance.get(`/${CONSIGNMENT_URL}/${id}/line`)
  },
  updateWeightDirty: (id, data) => {
    return instance.patch(`/${CONSIGNMENT_URL}/${id}/weight-dirty`, data)
  },
  utilization: (id, data) => {
    return instance.post(`/${CONSIGNMENT_URL}/${id}/scrap`, data)
  },
  goStageNext: (id, data) => {
    return instance.post(`/${CONSIGNMENT_URL}/${id}/next`, data)
  },
  goSplit: (id, data) => {
    return instance.post(`/${CONSIGNMENT_URL}/${id}/split`, data)
  },
  goStageBack: (id, data) => {
    return instance.post(`/${CONSIGNMENT_URL}/${id}/previous`, data)
  },
  getExport: (params = {}) => {
    return instance.get('/consignment/export', { params, responseType: 'blob' })
  },
  workTime: (id, data) => {
    return instance.post(`/consignment/work-time/${id}`, data)
  },
  statusLine: (id) => {
    return instance.get(`/consignment/get-status-line/${id}`)
  },
  setIndicators: (id, data) => {
    return instance.patch(`/${CONSIGNMENT_URL}/${id}/markers`, data)
  },
  setWeightDirtyWithLength: (id, data) => {
    return instance.post(`/${CONSIGNMENT_URL}/${id}/weight-dirty-with-length`, data)
  },
  getWeightDirtyWithLength: (id, data) => {
    return instance.get(`/${CONSIGNMENT_URL}/${id}/weight-dirty-with-length`)
  }
}
